import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Fragment, useCallback, useEffect } from 'react';
import { ItemsCreators } from '../../../store/actions/items';

import SalvarBallon from './SalvarBalloon/SalvarBalloon';
import Breadcrumbs from '../Breadcrumbs/index';

import './index.scss';

const BottomBar = (props) => {
  const {
    zoomLevel,
    setZoomLevel,
    setPanCurrent,
    items,
    showRightMenu,
    setInicialGroupPosition,
    hoveredItem,
  } = props;

  const updateZoomLevel = (value, showAll = false) => {
    if (showAll) {
      const objSize = calculateBoundAxis(items);
      const zoomAreaWidth = document.querySelector(
        '.builder__zoom-area'
      ).offsetWidth;
      const zoomAreaHeight = document.querySelector(
        '.builder__zoom-area'
      ).offsetHeight;
      const widthItem = 168.5; // largura de um bloco
      const valueX =
        (zoomAreaWidth * zoomLevel) /
        (objSize.maxValueX + widthItem + Math.abs(objSize.minValueX));
      const valueY =
        (zoomAreaHeight * zoomLevel) /
        (objSize.maxValueY + widthItem + Math.abs(objSize.minValueY));
      value = Math.min(valueX, valueY);
      setPanCurrent({
        x: Math.abs(objSize.minValueX),
        y: Math.abs(objSize.minValueY),
      });
    }
    setZoomLevel(value);
    toggleZoomMenu(false);
  };

  const calculateBoundAxis = (items) => {
    const obj = {
      maxValueX: 0,
      minValueX: 0,
      maxValueY: 0,
      minValueY: 0,
    };
    items.map((item) => {
      const x = item.positionOnScreen[0];
      const y = item.positionOnScreen[1];

      if (x > obj.maxValueX) obj.maxValueX = x;

      if (x < obj.minValueX) obj.minValueX = x;

      if (y > obj.maxValueY) obj.maxValueY = y;

      if (y < obj.minValueY) obj.minValueY = y;

      return item;
    });
    return obj;
  };

  const toggleZoomMenu = (toggle = true) => {
    const zoomMenu = document.getElementById('bottom-bar-zoom-menu');
    if (toggle) {
      zoomMenu.classList.toggle('is-zoom-menu-open');
    } else {
      zoomMenu.classList.remove('is-zoom-menu-open');
    }
  };

  const updateScroll = useCallback((event) => {
    if (event.ctrlKey) {
      if (event.deltaY > 0) {
        updateZoomLevel((z) => {
          const nz = (z - 0.05).toFixed(2);
          return Math.max(0.25, nz);
        });
      } else {
        setZoomLevel((z) => Math.min(2.0, (z + 0.05).toFixed(2)));
      }
    }
  }, []);

  useEffect(() => {
    document
      .getElementById('container-criador')
      .addEventListener('wheel', updateScroll);
    return () => {
      document
        .getElementById('container-criador')
        .removeEventListener('wheel', updateScroll);
    };
  }, [updateScroll]);

  return (
    <Fragment>
      <div className="bottom-bar">
        {/* ZOOOM */}
        <div>
          <button
            type="button"
            className="bottom-bar-zoom-button-plus-minus"
            onClick={() =>
              setZoomLevel((z) => Math.min(2.0, (z + 0.05).toFixed(2)))
            }
          >
            +
          </button>
          <button
            type="button"
            className="bottom-bar-zoom-button-percent"
            onClick={() => {
              toggleZoomMenu();
            }}
          >
            {(zoomLevel * 100 || 100).toFixed(2)}%
          </button>
          <button
            type="button"
            className="bottom-bar-zoom-button-plus-minus"
            onClick={() => {
              updateZoomLevel((z) => {
                const nz = (z - 0.05).toFixed(2);
                return Math.max(0.25, nz);
              });
            }}
          >
            -
          </button>
          <Breadcrumbs
            showRightMenu={showRightMenu}
            setInicialGroupPosition={setInicialGroupPosition}
          />
        </div>
        <div className="bottom-salvar">
          <SalvarBallon>
            {props.debounceList.length > 0 ? 'Salvando...' : 'Salvo'}
          </SalvarBallon>
        </div>
      </div>
      {/*  BOTTOM BAR ZOOM MENU */}
      <div id="bottom-bar-zoom-menu" className="bottom-bar-zoom-menu">
        <span className="pointer" onClick={() => updateZoomLevel(() => 2.0)}>
          <img src={require('../../../assets/images/zoom_mais.svg')} alt="" />{' '}
          200%
        </span>
        <span className="pointer" onClick={() => updateZoomLevel(() => 1.0)}>
          <img src={require('../../../assets/images/zoom_mais.svg')} alt="" />{' '}
          100%
        </span>
        <span className="pointer" onClick={() => updateZoomLevel(() => 0.5)}>
          <img src={require('../../../assets/images/zoom_menos.svg')} alt="" />{' '}
          50%
        </span>
        <span
          className="pointer"
          onClick={() => updateZoomLevel(() => 1.0, true)}
        >
          <img src={require('../../../assets/images/zoom_tudo.svg')} alt="" />{' '}
          Mostrar tudo
        </span>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  items: state.items.list,
  bot: state.bots.bot,
  currentItem: state.items.currentItem,
  debounceList: state.debounce.list,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...ItemsCreators }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BottomBar);
